import React from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const socials = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/kraftjustus/',
  icon: InstagramIcon
}, {
  label: 'Facebook',
  href: 'https://www.facebook.com/kraftjustus',
  icon: FacebookIcon
}, {
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/in/justus-kraft/',
  icon: LinkedinIcon
}];
export function Footer() {
  return <footer className="bg-[#0a0e1a] border-t border-white/5" data-id="element-106" data-mp="3ucxnryb833bd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-107" data-mp="37o2ul235f8m">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-108" data-mp="3levgx24t5gg6">
          <div data-id="element-109" data-mp="3qd6pzana3mxc">
            <Link to="/" className="flex items-center gap-2 mb-2" data-id="element-110" data-mp="3qcnk4sawkozo">
              <span className="text-lg font-bold text-white" data-id="element-111" data-mp="3qf9o6hyl4md5">CRM</span>
              <span className="text-lg font-bold text-[#ff6b35]" data-id="element-112" data-mp="29xvps9u757nq">Kraft</span>
            </Link>
            <p className="text-gray-500 text-sm max-w-md" data-id="element-113" data-mp="2ezutxlxrg8lq">
              <a href="https://crm-kraft.de/" className="text-gray-400 hover:text-white underline underline-offset-2 transition-colors" data-id="element-114" data-mp="3l90pe0juz71d">
                Close CRM Agentur
              </a>{' '}
              für Einrichtung, Automatisierungen, Dashboards und Betreuung –
              seit über 5 Jahren spezialisiert. Mehr auf{' '}
              <a href="https://crm-kraft.de/" className="text-gray-400 hover:text-white underline underline-offset-2 transition-colors" data-id="element-115" data-mp="830gdarw9qws">
                crm-kraft.de
              </a>
              .
            </p>
          </div>

          <div className="flex items-center gap-6" data-id="element-116" data-mp="huwlv6wb8jb1">
            <Link to="/impressum" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-117" data-mp="curzj08q0ucw">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-118" data-mp="qr5i6cozr1sy">
              Datenschutz
            </Link>
            <span className="w-px h-4 bg-white/10" aria-hidden="true" data-id="element-119" data-mp="tw5yi6q9bqmq" />
            {socials.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-120" data-mp="yuzd62ha5noh">
                <s.icon className="w-5 h-5" data-id="element-121" data-mp="1cmdzai6hi4zr" />
              </a>)}
          </div>
        </div>
        <p className="mt-8 text-gray-600 text-xs" data-id="element-122" data-mp="1hjnvqhsajgx3">
          © {new Date().getFullYear()} CRM Kraft LLC. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}